

















































































import { PaperGeneratedItem } from '@/resource/paper-generated-item/paper-generated-item.model';
import { GenerateQuestion } from '@/resource/question-generated/question-generated.model';
import {
  SCRIPT_CHART_JS_1,
  SCRIPT_CHART_JS_2,
  SCRIPT_MATHJAX_1,
  SCRIPT_VIS_JS_1,
  addScript,
  renderMathJax,
  isHasChartJs,
  isHasMath,
  isHasVisJs,
} from '@/utils/add-script';
import { axiosAi } from '@/utils/axios-generate-question';
import { extractQuestionAnswer } from '@/utils/question-generated-util';
import { Component, Prop, Vue } from 'vue-property-decorator';

async function replaceAllImages(question: string): Promise<string> {
  const { data } = await axiosAi.post('question-generated/generate-image', {
    question,
  });
  return data;
}

@Component({
  components: {},
})
export default class GeneratedQuestionContainer extends Vue {
  @Prop({ default: null })
  newQuestionGenerated: GenerateQuestion | null;

  @Prop({ default: null })
  paperGeneratedItem: PaperGeneratedItem | null;

  @Prop({ default: false })
  isForceEditable: boolean;

  @Prop({ default: false })
  showReplaceAllImages: boolean;

  questionHtml = '<div>ERROR STRING: Please try again<div>';
  answerHtml = '<div class="answer_container">No answer</div>';
  scriptContent: string | null = null;

  showAnswer = false;
  showQuestionEdit = false;
  showAnswerEdit = false;
  showQuestionEditButton = false;
  showAnswerEditButton = false;

  isLoadingReplaceImage = false;

  get isNotEditable() {
    if (this.isForceEditable) {
      return false;
    }

    if (
      this.paperGeneratedItem &&
      (this.paperGeneratedItem.selectedNewQuestionGenerated ||
        this.paperGeneratedItem.selectedNewQuestionGenerated === 0)
    ) {
      return false;
    }

    if (
      this.paperGeneratedItem &&
      this.paperGeneratedItem.questionGenerated &&
      !this.paperGeneratedItem.questionGenerated.parentId
    ) {
      return true;
    } else {
      return false;
    }
  }

  get isRunningScript() {
    if (this.isForceEditable) {
      return true;
    }

    if (this.paperGeneratedItem) {
      if (
        this.paperGeneratedItem &&
        this.paperGeneratedItem.questionGenerated &&
        !this.paperGeneratedItem.questionGenerated.parentId
      ) {
        if (this.paperGeneratedItem.selectedNewQuestionGenerated !== null) {
          return false;
        }

        return true;
      }
    }

    return false;
  }

  created() {
    this.extractHtml();
  }

  mounted() {
    this.addExternalScript();
  }

  extractHtml() {
    const originalHtml = `${
      this.newQuestionGenerated
        ? this.newQuestionGenerated.html
        : this.paperGeneratedItem && this.paperGeneratedItem.questionGenerated
        ? this.paperGeneratedItem.questionGenerated.html
        : ''
    }`;

    const { questionHtml, answerHtml, scriptContent } = extractQuestionAnswer(
      originalHtml,
    );
    this.answerHtml = answerHtml;
    this.questionHtml = questionHtml;

    if (scriptContent) {
      this.scriptContent = scriptContent;
    }
  }

  addExternalScript() {
    if (!this.isRunningScript) return;

    if (isHasChartJs(this.questionHtml)) {
      addScript({
        id: 'chart',
        link: SCRIPT_CHART_JS_1,
        onload: () => {
          addScript({
            id: 'chart-annotation',
            link: SCRIPT_CHART_JS_2,
            onload: this.runScript,
          });
        },
      });
    }

    if (isHasVisJs(this.questionHtml)) {
      addScript({
        id: 'chart',
        link: SCRIPT_VIS_JS_1,
        onload: this.runScript,
      });
    }

    if (isHasMath(this.questionHtml) || isHasMath(this.answerHtml)) {
      addScript({
        id: 'chart',
        link: SCRIPT_MATHJAX_1,
        onload: () => {
          renderMathJax(this.questionHtml);
          renderMathJax(this.answerHtml);
        },
      });
    }
  }

  runScript() {
    if (!this.isRunningScript) return;

    if (this.scriptContent) {
      const scriptContentFunc = new Function(this.scriptContent);
      scriptContentFunc();
      this.scriptContent = null;
    }
  }

  toggleAnswer() {
    this.showAnswer = !this.showAnswer;
  }

  toggleQuestionEdit() {
    this.showQuestionEdit = !this.showQuestionEdit;
  }

  hoverShowQuestionEditButton() {
    if (this.isNotEditable) return;
    this.showQuestionEditButton = true;
  }

  onhoverShowQuestionEditButton() {
    if (this.isNotEditable) return;
    this.showQuestionEditButton = false;
  }

  toggleAnswerEdit() {
    this.showAnswerEdit = !this.showAnswerEdit;
  }

  hoverShowAnswerEditButton() {
    if (this.isNotEditable) return;
    this.showAnswerEditButton = true;
  }

  onhoverShowAnswerEditButton() {
    if (this.isNotEditable) return;
    this.showAnswerEditButton = false;
  }

  async replaceAllImages() {
    if (this.isLoadingReplaceImage) return;

    const generatedQuestion =
      this.newQuestionGenerated || this.paperGeneratedItem
        ? this.paperGeneratedItem?.questionGenerated
        : null;

    if (generatedQuestion) {
      this.isLoadingReplaceImage = true;

      const newHtmlWithNewImages = await replaceAllImages(
        generatedQuestion.html,
      );

      if (this.paperGeneratedItem) {
        this.paperGeneratedItem.hasChange = true;
      }

      generatedQuestion.html = newHtmlWithNewImages;
      this.extractHtml();

      this.isLoadingReplaceImage = false;
    }
  }

  saveChanges() {
    if (this.newQuestionGenerated && this.paperGeneratedItem) {
      this.newQuestionGenerated.html = this.questionHtml + this.answerHtml;
      this.paperGeneratedItem.hasChange = true;
    }

    if (this.paperGeneratedItem && this.paperGeneratedItem.questionGenerated) {
      this.paperGeneratedItem.questionGenerated.html =
        this.questionHtml + this.answerHtml;

      this.paperGeneratedItem.hasChange = true;
    }

    this.extractHtml();
    this.runScript();

    if (this.showQuestionEdit) {
      this.showQuestionEdit = false;
    }

    if (this.showAnswerEdit) {
      this.showAnswerEdit = false;
    }
  }
}
